<h3>{{data.question}}</h3>

<button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
<button mat-button [mat-dialog-close]="false" cdkFocusInitial>No</button>